module.exports = "https://r.nearpod.com/assets/media/image/quick-launch-icon-7a53ee855169636d399a0e0c1bb58f9c.svg";